import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const TimerComponent = ({
  initialTime = { day: 0, hour: 0, minute: 0, second: 0 },
}) => {
  const [remainingTime, setRemainingTime] = useState(initialTime);
  console.log(remainingTime);
  const { t } = useTranslation();

  useEffect(() => {
    // Function to decrement the timer
    const decrementTime = () => {
      setRemainingTime((prevTime) => {
        let { day, hour, minute, second } = prevTime;

        if (second > 0) {
          second -= 1;
        } else {
          if (minute > 0) {
            minute -= 1;
            second = 59; // Reset seconds to 59
          } else {
            if (hour > 0) {
              hour -= 1;
              minute = 59; // Reset minutes to 59
              second = 59; // Reset seconds to 59
            } else {
              if (day > 0) {
                day -= 1;
                hour = 23; // Reset hours to 23
                minute = 59; // Reset minutes to 59
                second = 59; // Reset seconds to 59
              }
            }
          }
        }

        // If all time is zero, stop the timer
        if (day === 0 && hour === 0 && minute === 0 && second === 0) {
          clearInterval(interval);
        }

        return { day, hour, minute, second };
      });
    };

    const interval = setInterval(decrementTime, 1000); // Update every second

    return () => {
      clearInterval(interval); // Clean up the interval on unmount
    };
  }, []);

  const renderTimer = () => {
    return (
      <div className="relative w-full mb-20 mx-auto">
        <div className="flex flex-row gap-2 mx-auto relative  w-[90%]  px-2 z-20 justify-between   h-auto rounded-full">
          <div className="WeeklyStarTimerItem relative  flex flex-col gap-2 items-center pt-[4px]">
            <div className="flex flex-row gap-2 justify-center">
              <span className="text-[#FBEABF]  font-inter relative  text-center font-semibold text-[28px] leading-[2] tracking-normal  w-[43px] h-[44px] rounded-[5px]">
                {remainingTime.day}
              </span>
            </div>
            <span className="font-normal text-[#FBEABF] leading-none tracking-normal text-[18px] text-center">
              {t("Days")}
            </span>
          </div>

          <div className="WeeklyStarTimerItem relative flex flex-col items-center gap-2 pt-[4px]">
            <div className="flex flex-row gap-2   justify-center">
              <span className="text-[#FBEABF]  font-inter relative  text-center font-semibold text-[28px] leading-[2] tracking-normal  w-[43px] h-[44px] rounded-[5px]">
                {remainingTime.hour}
              </span>
            </div>
            <span className="font-normal text-[#FBEABF] leading-none tracking-normal text-[18px] text-center">
              {t("Hours")}
            </span>
          </div>

          <div className="WeeklyStarTimerItem relative  flex flex-col items-center gap-2  pt-[4px]">
            <div className="flex flex-row gap-2 justify-center">
              <span className="text-[#FBEABF]  font-inter relative  text-center font-semibold text-[28px] leading-[2] tracking-normal  w-[43px] h-[44px] rounded-[5px]">
                {remainingTime.minute}
              </span>
            </div>
            <span className="font-normal text-[#FBEABF] leading-none tracking-normal text-[18px] text-center">
              {t("Mins")}
            </span>
          </div>

          <div className="WeeklyStarTimerItem relative  flex flex-col items-center gap-2  pt-[4px]">
            <div className="flex flex-row gap-2 justify-center">
              <span className="text-[#FBEABF] text-center relative  font-inter font-semibold text-[28px] leading-[2] tracking-normal  w-[43px] h-[44px] rounded-[5px]">
                {remainingTime.second}
              </span>
            </div>
            <span className="font-normal text-[#FBEABF] leading-none tracking-normal text-[18px] text-center">
              {t("Secs")}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return renderTimer();
};

export default TimerComponent;
